import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getCouponTerms } from 'app/Components/Block/CouponTerms/CouponTermsSlice';

const CouponTerms = (props) => {
  const { getCouponTerms  } = props;

  const fetchCouponTerms = async () => {
    const couponType = new URLSearchParams(window.location.search).get('couponType');
    await getCouponTerms(couponType);
  };

  useEffect(() => {
    fetchCouponTerms();
  }, []);

  return null;
};

const mapStateToProps = (state) => ({
  couponTerms: state.couponTerms,
});

const mapDispatchToProps = {
  getCouponTerms
};

export default connect(mapStateToProps, mapDispatchToProps)(CouponTerms);
